/**
 * Created by m.igrachev on 7/20/2017.
 */
import Validator from "validator";
import validatorLocaleMap from "./validatorLocalesMap";
import decimalValidate from "./isDecimal";

export default function(toValidate, props) {
    let atLeastOneValidationWasChecked = false;
    let alphaPass = true;
    if (props.alpha) {
        atLeastOneValidationWasChecked = true;
        let toValidateArray = toValidate.split(" ");
        alphaPass = false;
        let locales = props.locales || ["english-uk"];
        for (let locale of locales) {
            let localeFound = true;
            for (let toValidateToken of toValidateArray) {
                if (!Validator.isAlpha(toValidateToken, validatorLocaleMap[locale])) {
                    localeFound = false;
                }
            }
            if (localeFound) {
                alphaPass = true;
                break;
            }
        }
    }

    let alphanumericPass = true;
    if (props.alphanumeric) {
        atLeastOneValidationWasChecked = true;
        let toValidateArray = toValidate.split(" ");
        alphanumericPass = false;
        let locales = props.locales || ["english-uk"];
        for (let locale of locales) {
            let localeFound = true;
            for (let toValidateToken of toValidateArray) {
                if (!Validator.isAlphanumeric(toValidateToken, validatorLocaleMap[locale])) {
                    localeFound = false;
                }
            }
            if (localeFound) {
                alphanumericPass = true;
                break;
            }
        }
    }

    let numericPass = true;
    if (props.numeric) {
        atLeastOneValidationWasChecked = true;
        numericPass = Validator.isNumeric(toValidate);
    }

    let eMailPass = true;
    if (props.eMail) {
        atLeastOneValidationWasChecked = true;
        eMailPass = Validator.isEmail(toValidate); //Note: we use the default (toValidate, [options]) parameter here!
    }

    let decimalPass = true;
    if (props.decimal) {
        atLeastOneValidationWasChecked = true;
        decimalPass = decimalValidate(toValidate);
    }

    let datePass = true;
    if (props.date) {
        atLeastOneValidationWasChecked = true;
        datePass = Validator.isDate(toValidate);
    }

    let lowercasePass = true;
    if (props.lowercase) {
        atLeastOneValidationWasChecked = true;
        lowercasePass = Validator.isLowercase(toValidate);
    }

    let uppercasePass = true;
    if (props.uppercase) {
        atLeastOneValidationWasChecked = true;
        uppercasePass = Validator.isUppercase(toValidate);
    }

    let result;
    if (atLeastOneValidationWasChecked) {
        result =
            alphaPass &&
            alphanumericPass &&
            numericPass &&
            eMailPass &&
            decimalPass &&
            datePass &&
            lowercasePass &&
            uppercasePass;
    }

    return result;
}
